import React, { useCallback, useEffect } from 'react'
import { DemographicsSection } from '../../../DemographicsSection'
import { useAnalysisMode } from '../../contexts/AnalysisModeContext'
import { useAnalysisServices } from '../../contexts/AnalysisServicesContext'
import { useAnalysisMapSectionData } from '../../contexts/MapSectionDataContext'

export const DemographicsTab: React.FC = () => {
  const { entity, userId, readOnly } = useAnalysisMode()
  const { getSectionData, updateSectionData, onDataFetched } =
    useAnalysisServices()
  const { setActiveSection, updateSectionData: updateMapData } =
    useAnalysisMapSectionData()

  useEffect(() => {
    setActiveSection('demographics')
  }, [setActiveSection])

  const handleDataFetched = useCallback(
    (data: any) => {
      onDataFetched('demographics', data)

      if (data?._isochrone) {
        updateMapData({
          demographics: {
            isochrone: data._isochrone,
            isochroneMode: data._isochroneMode,
          },
        })
      } else {
        updateMapData({
          demographics: {
            isochrone: null,
            isochroneMode: null,
          },
        })
      }
    },
    [onDataFetched, updateMapData]
  )

  const handleUpdateDemographicsData = useCallback(
    async (ent: any, uid: string, params: any) => {
      const result = await updateSectionData('demographics', ent, uid, params)
      handleDataFetched(result)
      return result
    },
    [updateSectionData, handleDataFetched]
  )

  if (!entity || !userId) return null

  return (
    <DemographicsSection
      entity={entity}
      userId={userId}
      getDemographicsData={() => getSectionData('demographics')}
      onDataFetched={handleDataFetched}
      updateDemographicsData={handleUpdateDemographicsData}
      readOnly={readOnly}
    />
  )
}
